import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a132fde4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column field" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "label"
}
const _hoisted_4 = {
  class: "mb-2",
  style: {"display":"flex"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Draw your signature on the signature pad.", -1))

import { ref } from "vue";
import SignaturePad from 'vue3-signature-pad';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignaturePadField',
  props: {
    label: null
  },
  setup(__props: any, { expose }) {



const signaturePad = ref(null);

const isSignatureEmpty = () => {
    return (signaturePad.value as any).isEmpty();
};

const getSignatureData = () => {
    return (signaturePad.value as any).saveSignature().data;
}

expose({
    isSignatureEmpty,
    getSignatureData
});

return (_ctx: any,_cache: any) => {
  const _component_SaveButton = _resolveComponent("SaveButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "top")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_SaveButton, {
        class: "ml-2",
        label: "Clear",
        icon: "fa-eraser",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ((signaturePad.value as any).clearSignature()))
      })
    ]),
    _createVNode(_unref(SignaturePad), {
      id: "pad",
      ref_key: "signaturePad",
      ref: signaturePad
    }, null, 512)
  ]))
}
}

})